import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum DeliveryAcceleratorsPageTabId {
	Accelerator = 1,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DeliveryAcceleratorsPageViewId {
	Accelerator = 1,
}



@Injectable({ providedIn: 'root' })
export class DeliveryAcceleratorsService extends PageTabsLayoutPageService<DeliveryAcceleratorsPageTabId, DeliveryAcceleratorsPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, DeliveryAcceleratorsPageViewId>[] = [
		{
			uniqueId: DeliveryAcceleratorsPageViewId.Accelerator,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Accelerators',
				hideText: 'never',
			}, customSort: '1-Accelerators-1'
		}]

	constructor() {
		super(DeliveryAcceleratorsService._viewDroplistItems, DeliveryAcceleratorsService.name, DeliveryAcceleratorsPageTabId.Accelerator, DeliveryAcceleratorsPageViewId.Accelerator);
	}
	public get viewId() {
		return DeliveryAcceleratorsPageViewId;
	}
}